import React from 'react';
import { Alert, Divider, Paper, Stack, Typography } from '@mui/material';

export default function MobileNotificationReviewStep({
  campaign,
  estimatedRecipients = 0,
  scheduleSummary = '',
}) {
  return (
    <Stack spacing={2}>
      <Alert severity="info">
        Review the campaign. Sending creates a mobile-only inbox row per targeted employee, with push attempted only for users who have a registered Expo token.
      </Alert>

      <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={1.25}>
          <Typography variant="subtitle2">Title</Typography>
          <Typography variant="body2">{campaign?.title || '-'}</Typography>

          <Divider />

          <Typography variant="subtitle2">Message</Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {campaign?.message || '-'}
          </Typography>

          <Divider />

          <Typography variant="subtitle2">Audience</Typography>
          <Typography variant="body2">
            {(() => {
              const mode = campaign?.audience_mode || 'all';
              const labels = {
                all: 'All employees',
                by_role: 'By role',
                by_department: 'By department',
                by_employee: 'Specific employees',
                advanced: 'Advanced rules',
                all_devices: 'All app installs (incl. not logged in)',
              };
              return labels[mode] || mode;
            })()}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {(campaign?.audience_mode === 'all_devices')
              ? 'Every device in app_devices receives a push (employee filters do not apply).'
              : `Estimated recipients: ${Number(estimatedRecipients || 0)}`}
          </Typography>

          <Divider />

          <Typography variant="subtitle2">Schedule</Typography>
          <Typography variant="body2">{scheduleSummary || '-'}</Typography>
        </Stack>
      </Paper>
    </Stack>
  );
}
